var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8422 13.8218L20.2306 0.199859C19.8719 -0.0614114 19.3853 -0.0614114 19.0267 0.199859L0.41498 13.8218C-0.0409624 14.1548 -0.138298 14.7951 0.194693 15.246C0.527685 15.7019 1.16805 15.7992 1.61887 15.4663L19.6312 2.2849L37.6383 15.4714C37.8228 15.6046 38.0328 15.666 38.2377 15.666C38.5502 15.666 38.8627 15.5226 39.0625 15.246C39.3955 14.7951 39.2982 14.1548 38.8422 13.8218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9088 15.7017C33.3452 15.7017 32.8893 16.1576 32.8893 16.7211V32.9609H24.7284V24.0982C24.7284 21.2857 22.4385 18.9957 19.626 18.9957C16.8135 18.9957 14.5235 21.2857 14.5235 24.0982V32.9609H6.36267V16.7211C6.36267 16.1576 5.90672 15.7017 5.3432 15.7017C4.77967 15.7017 4.32373 16.1576 4.32373 16.7211V33.9804C4.32373 34.5439 4.77967 34.9998 5.3432 34.9998H15.543C16.0809 34.9998 16.5164 34.5849 16.5573 34.0572C16.5573 34.0316 16.5573 34.006 16.5573 33.9804V24.0982C16.5573 22.4127 17.9303 21.0398 19.6157 21.0398C21.3012 21.0398 22.6741 22.4127 22.6741 24.0982V33.9804C22.6741 34.006 22.6741 34.0367 22.6741 34.0572C22.7151 34.5849 23.1557 34.9998 23.6885 34.9998H33.8883C34.4518 34.9998 34.9077 34.5439 34.9077 33.9804V16.7211C34.9077 16.1576 34.4518 15.7017 33.8883 15.7017H33.9088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2623,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.f562a1ffa0f79c1f1b32c2d949eecde8.svg";
export { ForwardRef as ReactComponent };